import React, { useState, useEffect } from "react";
import {
  TextField,
  InputAdornment,
  Typography,
  Button,
  FormHelperText,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import dayjs, { Dayjs } from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import backicon from "../Components/assets/Images/back.svg";
import { useNavigate } from "react-router-dom";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import { IPanDetails } from "../shared/dtos";
import { panDetailsAPICall, stageDetailsAPICall } from "../shared/APICalls";
import routesData from "../shared/routes.json";
import PanStyles from "../pages/Styles/PanVerification.module.scss";
import calenderImage from "../Components/assets/Images/calendar.svg";
import SnackBar from "../Components/SnackBars/SnackBar";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import keyboardicon from "../Components/assets/Images/stepkeyboard.svg";
import { useDispatch } from "react-redux";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";

const schema = Yup.object().shape({
  pannumber: Yup.string()

    .required("Pan Number is Required")
    .max(10)
    .matches(
      /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
      "Enter Valid Pan Number"
    )
    .transform((value: any) => value && value.toUpperCase()),

  dateofBirth: Yup.string().required("Date of Birth is a required field"),
});

function DateIcon(props) {
  return <img src={calenderImage} style={{ width: "25px" }} />;
}

export default function PanVerificationPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [pan, setPan] = useState("");
  const [dobError, setDobError] = useState("");
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState<any>("");
  const [panPrefill, setPanPrefill] = useState("");
  const [dobPrefill, setPanDobfill] = useState<any>("");

  const [prefilloading, setprefilloading] = useState(true);
  const [rejectMessage, setRejectMessage] = useState("");

  const navigationData = routesData;

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);

    let obj: any = {
      stage: "pan",
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        setprefilloading(false);
        const responseData = response.data;
        dispatch(setCompletedStages(responseData?.data?.completed_stages));
        dispatch(setCurrentStage(responseData?.data?.current_stage));
        setRejectMessage(response.data.data.ErrorMessage);

        setPanPrefill(response?.data?.data?.data?.pan_no);
        if (response?.data?.data?.data?.dob) {
          setPanDobfill(dayjs(response?.data?.data?.data?.dob));
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
        setprefilloading(false);
      });
  }, []);

  function panDetails(date: any, pan: any, name: any) {
    setloading(true);
    let obj: IPanDetails = {
      name: name.toUpperCase(),
      pan_no: pan.toUpperCase(),
      dob: date,
    };
    // console.log("obj", obj);
    panDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;

        if (!responseData) {
          setMessage("Failed to get Data");
          setTimeout(() => {
            setMessage("");
          }, 5000);
        }

        setloading(false);
        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
      })
      .catch((error: any) => {
        //console.log("error", error);
        setloading(false);

        setMessage(
          error.message.includes("Network")
            ? "Error Occured, Please try again"
            : error.response.data.message
        );

        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  }

  const handleClick = (
    dob: any,
    formatedDate: any,
    panNumber: any,
    name: any
  ) => {
    const dobLimit = new Date();
    dobLimit.setFullYear(dobLimit.getFullYear() - 18);
    if (!dob || dob > dobLimit) {
      // setDobError(true);

      setDobError("Your Age is Below 18");
      setTimeout(() => {
        setDobError("");
      }, 3000);
      // alert("Your Age is Below 18");
    } else {
      panDetails(formatedDate, panNumber, name);
    }
  };

  const eighteenYearsAgo = dayjs().subtract(18, "year");
  const maxDate = dayjs("1940-01-01");

  const renderYear = (year) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {year - maxDate.year()}
      </div>
    );
  };

  return (
    <>
      <div className={PanStyles.mainWrapper}>
        {prefilloading && (
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}

        <div className={PanStyles.wrapper}>
          <div
            className={PanStyles.backTop}
            onClick={() => {
              navigate("/tradingPreference");
            }}
          >
            <img src={backicon} />{" "}
            <span className={PanStyles.backText}>Back</span>
          </div>
          <div className={PanStyles.step}>
            <img src={keyboardicon} /> Step 1 of 10
          </div>
          <div className={PanStyles.RightContainer}>
            {!prefilloading ? (
              <>
                <div className={PanStyles.headerSection}>
                  <p className={PanStyles.signup}>Enter Your PAN Details</p>
                  <p className={PanStyles.subText}>
                    Your PAN is needed to verify your identity
                  </p>
                </div>

                <Formik
                  validationSchema={schema}
                  initialValues={{
                    // name: namePrefill === "" ? "" : namePrefill,
                    pannumber: panPrefill === "" ? "" : panPrefill,
                    dateofBirth: dobPrefill === "" ? null : dobPrefill,
                  }}
                  onSubmit={(values: any) => {
                    const date = new Date(values.dateofBirth.$d);
                    // console.log(date);
                    const formattedDate = date.toLocaleDateString("en-GB", {
                      year: "numeric",
                      day: "2-digit",
                      month: "2-digit",
                    });
                    const [month, day, year] = formattedDate.split("/");
                    const formatDate = `${year}/${day}/${month}`;
                    //  console.log(formatDate);
                    handleClick(
                      values.dateofBirth.$d,
                      formatDate,
                      values.pannumber,
                      "DEMO"
                    );
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                  }) => (
                    <>
                      <form
                        noValidate
                        onSubmit={handleSubmit}
                        onKeyDown={(event) => {
                          event.code === "Enter" ||
                            (event.code === "NumpadEnter" && handleSubmit());
                          // event.code.includes("Enter") && handleSubmit()
                        }}
                        style={{ width: "100%" }}
                      >
                        <>
                          <div className={PanStyles.textfeildSection}>
                            <div>
                              <TextField
                                className={PanStyles.textfeild}
                                id="outlined-basic"
                                label="PAN"
                                placeholder="PAN"
                                name="pannumber"
                                variant="outlined"
                                value={values.pannumber.toUpperCase()}
                                error={
                                  touched.pannumber && Boolean(errors.pannumber)
                                }
                                helperText={
                                  touched.pannumber &&
                                  errors.pannumber?.toString()
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                inputProps={{
                                  sx: {
                                    "&::label": {
                                      fill: "#111827",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                    },
                                    color: "var(--Black-Black-500, #6B7280)",
                                    fontSize: "14px",
                                  },
                                  maxLength: 10,
                                }}
                                sx={{
                                  fieldset: {
                                    borderColor: "#E5E7EB",
                                    borderRadius: "100px",
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: "#6B7280",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    "&.MuiFormLabel-filled": {
                                      color: "#111827",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                    },
                                  },
                                }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Typography color="textSecondary">
                                        {values.pannumber.length}/10
                                      </Typography>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </div>
                            {/* <FormHelperText style={{ color: "#d32f2f" }}>
                            {message}
                          </FormHelperText> */}
                            <div>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["DatePicker"]}>
                                  <DatePicker
                                    className={PanStyles.datePicker}
                                    components={{ OpenPickerIcon: DateIcon }}
                                    minDate={maxDate}
                                    maxDate={eighteenYearsAgo}
                                    format="DD/MM/YYYY"
                                    renderYear={renderYear}
                                    views={["year", "month", "day"]}
                                    label="DOB as per PAN"
                                    name="dateofBirth"
                                    value={values.dateofBirth}
                                    // value={
                                    //   values.dateofBirth

                                    // }
                                    onChange={(date) => {
                                      handleChange({
                                        target: {
                                          name: "dateofBirth",
                                          value: date,
                                        },
                                      });
                                    }}
                                    onBlur={handleBlur}
                                    error={
                                      touched.dateofBirth &&
                                      Boolean(errors.dateofBirth)
                                    }
                                    helperText={
                                      touched.dateofBirth && errors.dateofBirth
                                    }
                                    renderInput={(params: any) => (
                                      <TextField {...params} />
                                    )}
                                    {...(DatePicker as any)}
                                    InputLabelProps={{
                                      sx: {
                                        color: "grey",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        "&.MuiFormLabel-filled": {
                                          color: "#111827",
                                        },
                                      },
                                    }}
                                    sx={{
                                      width: "100%",
                                      fieldset: {
                                        borderColor: "#E5E7EB",
                                        borderRadius: "100px",
                                      },
                                      "& .MuiInputLabel-root": {
                                        color: "#6B7280",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        "&.Mui-focused": {
                                          color: "#111827",
                                        },
                                        "&.MuiFormLabel-filled": {
                                          color: "#111827",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                        },
                                      },
                                      "& .MuiOutlinedInput-input": {
                                        color:
                                          "var(--Black-Black-500, #6B7280)",
                                        fontSize: "14px",
                                      },
                                    }}
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                              <FormHelperText style={{ color: "#d32f2f" }}>
                                {dobError}
                              </FormHelperText>
                            </div>
                          </div>

                          <div className={PanStyles.buttonSection}>
                            {(values.dateofBirth && values.pannumber) ||
                            (dobPrefill && panPrefill) ? (
                              <LoadingButton
                                type="submit"
                                variant="contained"
                                loading={loading}
                                id="panVerificationContinueButton"
                                className={PanStyles.button}
                                onClick={() => {
                                  handleSubmit();
                                }}
                              >
                                Continue
                              </LoadingButton>
                            ) : (
                              <Button
                                type="submit"
                                variant="contained"
                                disabled
                                className={PanStyles.button}
                              >
                                Continue
                              </Button>
                            )}
                          </div>
                          <div className={PanStyles.bottomContentContainer}>
                            <p className={PanStyles.bottomContent}>
                              - Your account name would be taken as per the name
                              registered on the Income Tax Database
                            </p>
                            <p className={PanStyles.bottomContent}>
                              - To open an account online, ensure your mobile
                              number is linked to your Aadhaar; otherwise, you
                              will need to{" "}
                              <a
                                href="https://firstock-common.s3.ap-south-1.amazonaws.com/forms/Individual+Application+.pdf"
                                target="_blank"
                                style={{
                                  textDecoration: "underline",
                                  color: "blue",
                                }}
                              >
                                proceed offline
                              </a>
                              . We do not collect or store your Aadhaar number
                            </p>
                            <p className={PanStyles.bottomContent}>
                              - For online account opening, use Digi locker for
                              identity verification if you are not KRA verified,
                              and digitally sign the application.
                            </p>
                            <p className={PanStyles.bottomContent}>
                              - For HUF, Corporate, Partnership, or NRI
                              accounts,{" "}
                              <a
                                href="https://firstock-common.s3.ap-south-1.amazonaws.com/forms/Individual+Application+.pdf"
                                target="_blank"
                                style={{
                                  textDecoration: "underline",
                                  color: "blue",
                                }}
                              >
                                offline forms
                              </a>{" "}
                              must be completed.
                            </p>
                          </div>
                          <ErrorSnackBar message={rejectMessage} />
                          <SnackBar message={message} />
                        </>
                      </form>
                    </>
                  )}
                </Formik>
              </>
            ) : (
              <>
                <Backdrop
                  sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                  }}
                  open={true}
                >
                  <CircularProgress color="inherit" />
                </Backdrop>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
